import { useState } from "react";
import {
  ListChecks,
  Clock,
  AlertCircle,
  PhoneCall,
  CheckCircle2,
} from "lucide-react";

export default function StatusCards({ statusCounts, onSelectStatus }) {
  const [active, setActive] = useState(null);

  const defaults = {
    todos: 0,
    aberto: 0,
    pendente: 0,
    atendendo: 0,
    finalizado: 0,
  };

  const counts = { ...defaults, ...(statusCounts || {}) };

  const cards = [
    {
      key: "Todos",
      title: "Todos",
      count: counts.todos,
      color: "bg-slate-500",
      light: "bg-slate-100", // fundo claro
      icon: <ListChecks className="text-slate-600" size={22} />,
    },
    {
      key: "Aberto",
      title: "Aberto",
      count: counts.aberto,
      color: "bg-yellow-500",
      light: "bg-yellow-100",
      icon: <Clock className="text-yellow-600" size={22} />,
    },
    {
      key: "Pendente",
      title: "Pendente",
      count: counts.pendente,
      color: "bg-red-500",
      light: "bg-red-100",
      icon: <AlertCircle className="text-red-600" size={22} />,
    },
    {
      key: "Atendendo",
      title: "Atendendo",
      count: counts.atendendo,
      color: "bg-blue-500",
      light: "bg-blue-100",
      icon: <PhoneCall className="text-blue-600" size={22} />,
    },
    {
      key: "Finalizado",
      title: "Finalizado",
      count: counts.finalizado,
      color: "bg-green-500",
      light: "bg-green-100",
      icon: <CheckCircle2 className="text-green-600" size={22} />,
    },
  ];

  return (
    <div className="grid grid-cols-5 gap-4 p-4">
      {cards.map((card, index) => (
        <div
          key={card.key}
          onClick={() => {
            setActive(index);
            if (onSelectStatus) {
              onSelectStatus(card.key === "Todos" ? "" : card.key);
            }
          }}
          className={`relative ${card.light} p-3 rounded-md shadow-sm border 
                      flex flex-col items-center justify-center h-28 
                      cursor-pointer transition-transform duration-200
                      hover:shadow-lg hover:scale-105
                      ${active === index ? "border-b-4 border-black" : ""}`}
        >
          {/* Faixa no topo */}
          <div
            className={`absolute top-0 left-0 w-full h-2 rounded-t-md ${card.color}`}
          />
          <div className="flex flex-col items-center justify-center mt-2">
            <div className="mb-1">{card.icon}</div>
            <h3 className="font-semibold text-slate-700 text-sm">
              {card.title}
            </h3>
            <p className="text-lg font-bold text-slate-800 mt-1">{card.count}</p>
            <span className="text-xs text-slate-500">ITENS</span>
          </div>
        </div>
      ))}
    </div>
  );
}
